<template>
  <div class="modal_user">
    <div class="modal_user__header">
      <h4 class="title">
        {{ primary_data.name }}
      </h4>
    </div>
    <div class="modal_user__body">
      <div class="user">
        <div class="tab">
          <span class="tab_title" :class="{ active : block==='MainInfo'}" @click="selected_block('MainInfo')">{{this.translate('user.main_info.title')}}</span>
          <span class="tab_title" :class="{ active : block==='RoleManagement'}" @click="selected_block('RoleManagement')">{{this.translate('user.role_manage.my_role')}}</span>
          <span class="tab_title" :class="{ active : block==='Settings'}" @click="selected_block('Settings')">{{this.translate('user.settings .title')}}</span>
          <!--          <span class="tab_title" v-if="primary_data.id" :class="{ active : block==='Comments'}" @click="selected_block('Comments')">{{this.translate('user.comments.title')}}</span>-->
        </div>
        <div class="block">
          <MainInfo v-if="block==='MainInfo'" :main_info="main_info" @update_user="update_user"/>
          <RoleManagement v-if="block==='RoleManagement'" :roles_and_permissions="roles_and_permissions" />
          <Settings v-if="block==='Settings'" />
<!--          <Comments v-if="block==='Comments'" :params="comments_params" />-->
        </div>
      </div>


    </div>
    <div class="modal_user__footer">
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="cancel"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
    </div>

  </div>
</template>
<script>

import MainInfo from "./Tabs/MainInfo";
import Settings from "./Tabs/Settings.vue";
import RoleManagement from "./Tabs/RoleManagement.vue";
import Comments from "@/views/Dashboard/common/General/Summary/Comments.vue";

export default {
  name: 'ShowUser',
  props: ['user', 'client_ids'],
  components: {
    MainInfo,
    Settings,
    RoleManagement,
    Comments
  },
  data () {
    return {
      block: 'MainInfo',
      disabled_btn: false,
      primary_data: {
        name: ''
      },
      roles_and_permissions: {}
    }
  },
  created() {
    this.get_user_profile()

    this.primary_data = {...this.user}
  },

  computed:{
    main_info(){
      return {...this.primary_data}
    },
  },

  methods: {
    update_user(data){
      this.primary_data = data
      this.$emit('update')
    },
    update_groups(groups){
      this.primary_data.group = groups
      this.$emit('update')
    },
    cancel () {
      this.$emit('close')
    },
    selected_block(block){
      this.block = block
    },
    get_user_profile () {
      this.$http.v1.getUserProfile((response) => {
        this.roles_and_permissions.permissions = response.data.permissions
        this.roles_and_permissions.roles = response.data.roles
      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .modal_user{
    height: 100%;
    padding: 10px;
    &__header{
      height: 5%;
      .title{
        margin: 0 0 10px 0;
        text-align: center;
      }
    }
    &__body{
      width: 100%;
      height: 90%;
      .loading{
        border:none;
        background-color: transparent;
      }
      .user{
        width: 100%;
        height: 100%;
        .tab{
          width: 100%;
          height: 5%;
          display: flex;
          align-content: center;
          justify-content: center;
          flex-direction: row;
          &_title{
            width: 100%;
            padding: 5px 0;
            cursor: pointer;
            font-weight: 600;
            text-align: center;
            background-color: #efe9e9;
            border: 1px solid #efe9e9;
            &.active{
              background-color: #FFFFFF;
              border-bottom: 1px solid white;
            }
          }
        }
        .block{
          height: 95%;
          border: 1px solid #efe9e9;
          margin-top: -1px;
          padding: 10px;
        }
      }

    }
    &__footer{
      height: 5%;
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }


</style>
